import { render, staticRenderFns } from "./ResultsImportPanel.vue?vue&type=template&id=10b03936&"
import script from "./ResultsImportPanel.vue?vue&type=script&lang=js&"
export * from "./ResultsImportPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports